/// burayı atma git'e

const getEnvVar = (key) => {
      const value = process.env[key];

      return value === "" ? undefined : value;
};

const getEnvNumber = (key) => {
      const value = process.env[key];

      if (value === undefined || value === "") {
            return undefined;
      }

      const parsed = Number(value);

      return Number.isNaN(parsed) ? undefined : parsed;
};
//deneme
const config = {
      defaultProfileImageUrl: "/uploads/images/user.jpg",
      maintanence: false, //bakım çalışması  test

      copright: 'Her hakkı saklıdır. Atatürk Kültür, Dil ve Tarih Yüksek Kurumu',
      coprightYear: '2019',

      sk: getEnvVar('REACT_APP_SK'),
      googleCaptchaSiteKey: getEnvVar('REACT_APP_GOOGLE_CAPTCHA_SITE_KEY'),


      apiUrl: getEnvVar('REACT_APP_API_URL'),
      mainPageUrl: getEnvVar('REACT_APP_MAIN_PAGE_URL'),
      bilsisUrl: getEnvVar('REACT_APP_BILSIS_URL'),
      yaysisUrl: getEnvVar('REACT_APP_YAYSIS_URL'),
      saysUrl: getEnvVar('REACT_APP_SAYS_URL'),
      kurulsisUrl: getEnvVar('REACT_APP_KURULSIS_URL'),
      eDevlet:
      {
            directUrl: getEnvVar('REACT_APP_EDEVLET_DIRECT_URL'),
            redirectUrl: getEnvVar('REACT_APP_EDEVLET_REDIRECT_URL'),
            clientID: getEnvVar('REACT_APP_EDEVLET_CLIENT_ID'),
            key: getEnvVar('REACT_APP_EDEVLET_KEY'),

            destek: {
                  directUrl: getEnvVar('REACT_APP_EDEVLET_DESTEK_DIRECT_URL'),
                  redirectUrl: getEnvVar('REACT_APP_EDEVLET_DESTEK_REDIRECT_URL'),
                  clientID: getEnvVar('REACT_APP_EDEVLET_DESTEK_CLIENT_ID'),
                  key: getEnvVar('REACT_APP_EDEVLET_DESTEK_KEY'),
            },
            proje: {
                  directUrl: getEnvVar('REACT_APP_EDEVLET_PROJE_DIRECT_URL'),
                  redirectUrl: getEnvVar('REACT_APP_EDEVLET_PROJE_REDIRECT_URL'),
                  clientID: getEnvVar('REACT_APP_EDEVLET_PROJE_CLIENT_ID'),
                  key: getEnvVar('REACT_APP_EDEVLET_PROJE_KEY'),
            }
      }

      ,
      testConfig: {
            apiUrl: getEnvVar('REACT_APP_TEST_API_URL'),
            mainPageUrl: getEnvVar('REACT_APP_TEST_MAIN_PAGE_URL'),
            bilsisUrl: getEnvVar('REACT_APP_TEST_BILSIS_URL'),
            saysUrl: getEnvVar('REACT_APP_TEST_SAYS_URL'),
            yaysisUrl: getEnvVar('REACT_APP_TEST_YAYSIS_URL'),
            kurulsisUrl: getEnvVar('REACT_APP_TEST_KURULSIS_URL'),

            eDevlet:
            {
                  directUrl: getEnvVar('REACT_APP_TEST_EDEVLET_DIRECT_URL'),
                  redirectUrl: getEnvVar('REACT_APP_TEST_EDEVLET_REDIRECT_URL'),
                  clientID: getEnvVar('REACT_APP_TEST_EDEVLET_CLIENT_ID'),
                  key: getEnvVar('REACT_APP_TEST_EDEVLET_KEY'),

                  destek: {
                        directUrl: getEnvVar('REACT_APP_TEST_EDEVLET_DESTEK_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_TEST_EDEVLET_DESTEK_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_TEST_EDEVLET_DESTEK_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_TEST_EDEVLET_DESTEK_KEY'),
                  },
                  proje: {
                        directUrl: getEnvVar('REACT_APP_TEST_EDEVLET_PROJE_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_TEST_EDEVLET_PROJE_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_TEST_EDEVLET_PROJE_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_TEST_EDEVLET_PROJE_KEY'),
                  }
            }
      },
      prodConfig: {
            apiUrl: getEnvVar('REACT_APP_PROD_API_URL'),
            mainPageUrl: getEnvVar('REACT_APP_PROD_MAIN_PAGE_URL'),
            bilsisUrl: getEnvVar('REACT_APP_PROD_BILSIS_URL'),
            saysUrl: getEnvVar('REACT_APP_PROD_SAYS_URL'),
            yaysisUrl: getEnvVar('REACT_APP_PROD_YAYSIS_URL'),
            kurulsisUrl: getEnvVar('REACT_APP_PROD_KURULSIS_URL'),

            eDevlet:
            {
                  directUrl: getEnvVar('REACT_APP_PROD_EDEVLET_DIRECT_URL'),
                  redirectUrl: getEnvVar('REACT_APP_PROD_EDEVLET_REDIRECT_URL'),
                  clientID: getEnvVar('REACT_APP_PROD_EDEVLET_CLIENT_ID'),
                  key: getEnvVar('REACT_APP_PROD_EDEVLET_KEY'),
                  serviceId: getEnvNumber('REACT_APP_PROD_EDEVLET_SERVICE_ID'),


                  destek: {
                        directUrl: getEnvVar('REACT_APP_PROD_EDEVLET_DESTEK_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_PROD_EDEVLET_DESTEK_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_PROD_EDEVLET_DESTEK_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_PROD_EDEVLET_DESTEK_KEY'),
                        serviceId: getEnvNumber('REACT_APP_PROD_EDEVLET_DESTEK_SERVICE_ID')

                  },
                  proje: {
                        directUrl: getEnvVar('REACT_APP_PROD_EDEVLET_PROJE_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_PROD_EDEVLET_PROJE_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_PROD_EDEVLET_PROJE_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_PROD_EDEVLET_PROJE_KEY'),
                        serviceId: getEnvNumber('REACT_APP_PROD_EDEVLET_PROJE_SERVICE_ID')

                  },
                  yaysis: {
                        directUrl: getEnvVar('REACT_APP_PROD_EDEVLET_YAYSIS_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_PROD_EDEVLET_YAYSIS_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_PROD_EDEVLET_YAYSIS_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_PROD_EDEVLET_YAYSIS_KEY'),
                        serviceId: getEnvNumber('REACT_APP_PROD_EDEVLET_YAYSIS_SERVICE_ID')

                  },
                  bilsis: {
                        directUrl: getEnvVar('REACT_APP_PROD_EDEVLET_BILSIS_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_PROD_EDEVLET_BILSIS_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_PROD_EDEVLET_BILSIS_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_PROD_EDEVLET_BILSIS_KEY'),
                        serviceId: getEnvNumber('REACT_APP_PROD_EDEVLET_BILSIS_SERVICE_ID')
                  },
                  absis: {
                        directUrl: getEnvVar('REACT_APP_PROD_EDEVLET_ABSIS_DIRECT_URL'),
                        redirectUrl: getEnvVar('REACT_APP_PROD_EDEVLET_ABSIS_REDIRECT_URL'),
                        clientID: getEnvVar('REACT_APP_PROD_EDEVLET_ABSIS_CLIENT_ID'),
                        key: getEnvVar('REACT_APP_PROD_EDEVLET_ABSIS_KEY'),
                        serviceId: getEnvNumber('REACT_APP_PROD_EDEVLET_ABSIS_SERVICE_ID')

                  },
            }
      },

      absis: {
            orcid: {
                  apiUrl: getEnvVar('REACT_APP_ABSIS_ORCID_API_URL'),
            }
      },
      journals: [
            { id: 1, name: "Türk Dili", inst: "TDK" },
            { id: 2, name: "Türk Dünyası", inst: "TDK" },
            { id: 3, name: "Belleten", inst: "TDK" },
            { id: 4, name: "Belleten", inst: "TTK" },
            { id: 5, name: "Belgeler", inst: "TTK" },
            { id: 6, name: "Atatürk Araştırma Merkezi Dergisi", inst: "ATAM" },
            { id: 7, name: "Erdem", inst: "AKM" },
            { id: 8, name: "Bilge", inst: "AKM" },
            { id: 9, name: "Arış", inst: "AKM" },
            { id: 10, name: "Höyük", inst: "TTK" },

      ],
      //nurdoğan 18.08.2025
      titleList: [
            "Dr.",
            "Dr. Öğretim Üyesi",
            "Doç. Dr.",
            "Prof. Dr.",
            "Öğretim Görevlisi",
            "Araştırma Görevlisi",
            "Öğretim Görevlisi Dr.",
            "Araştırma Görevlisi Dr.",
            "Öğretmen",
            //  "Diğer",
      ],


      titleListLong: [
            "Araştırma Profesörü",
            "Doçent",
            "Doktor",
            "Doktor Öğretim Üyesi",
            "Yardımcı Doçent",
            "Ordinaryüs",
            "Profesör",
            "Araştırma Görevlisi",
            "Çevirmen",
            "Okutman",

            "Öğretim Görevlisi",
            "Öğretim Görevlisi Dr.",
            "Araştırma Görevlisi Dr.",
            "Öğretim Planlamacısı",
            "Uzman",
            "Öğretmen"],

      degreeListLong: [
            "Önlisans",
            "Lisans",
            "Lisans-Anadal",
            "Lisans-Yandal",
            "Lisans Tamamlama",
            "Bilimsel Hazırlık",
            "Yüksek Lisans",
            "Yüksek Lisans - Tezli",
            "Yüksek Lisans - Tezsiz",
            "Bütünleşik Doktora",
            "Doktora"
      ],

      mounth: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
      citys: ['', 'Adana', 'Adıyaman', 'Afyon', 'Ağrı', 'Amasya', 'Ankara', 'Antalya', 'Artvin',
            'Aydın', 'Balıkesir', 'Bilecik', 'Bingöl', 'Bitlis', 'Bolu', 'Burdur', 'Bursa', 'Çanakkale',
            'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır', 'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir',
            'Gaziantep', 'Giresun', 'Gümüşhane', 'Hakkari', 'Hatay', 'Isparta', 'Mersin', 'İstanbul', 'İzmir',
            'Kars', 'Kastamonu', 'Kayseri', 'Kırklareli', 'Kırşehir', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya',
            'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş', 'Nevşehir', 'Niğde', 'Ordu', 'Rize', 'Sakarya',
            'Samsun', 'Siirt', 'Sinop', 'Sivas', 'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Şanlıurfa', 'Uşak',
            'Van', 'Yozgat', 'Zonguldak', 'Aksaray', 'Bayburt', 'Karaman', 'Kırıkkale', 'Batman', 'Şırnak',
            'Bartın', 'Ardahan', 'Iğdır', 'Yalova', 'Karabük', 'Kilis', 'Osmaniye', 'Düzce'],


      educationLevels: ["", "Okur-Yazar Değil", "Okur-Yazar", "İlkokul", "Ortaokul", "Lise", "Lisans", "YüksekLisans", "Doktora"],

      eBookInfoOptions: [
            "Elektronik Yayın",
            "Matbu Yayın",
            "Elektronik ve Matbu Yayın"
      ],

      fileAcceptExtension: [
            'video/x-flv'
            , 'video/mp4'
            , 'application/x-mpegURL'
            , 'video/MP2T'
            , 'video/3gpp'
            , 'video/quicktime'
            , 'video/x-msvideo'
            , 'video/x-ms-wmv'
            , 'audio/basic'
            , 'audio/mid'
            , 'audio/mpeg	RFC 3003'
            , 'audio	audio/mp4'
            , 'audio/x-mpegurl'
            , 'Vorbis	audio/ogg	RFC 5334'
            , 'audio/vnd.wav'
            , 'image/cgm'
            , 'image/fits'
            , 'image/g3fax'
            , 'image/gif'
            , 'image/ief'
            , 'image/jp2'
            , 'image/jpeg'
            , 'image/jpm'
            , 'image/jpx'
            , 'image/naplps'
            , 'image/png'
            , 'image/prs.btif'
            , 'image/prs.pti'
            , 'image/t38'
            , 'image/tiff'
            , 'image/tiff-fx'
            , 'image/vnd.adobe.photoshop'
            , 'image/vnd.cns.inf2'
            , 'image/vnd.djvu'
            , 'image/vnd.dwg'
            , 'image/vnd.dxf'
            , 'image/vnd.fastbidsheet'
            , 'image/vnd.fpx'
            , 'image/vnd.fst'
            , 'image/vnd.fujixerox.edmics-mmr'
            , 'image/vnd.fujixerox.edmics-rlc'
            , 'image/vnd.globalgraphics.pgb'
            , 'image/vnd.microsoft.icon'
            , 'image/vnd.mix'
            , 'image/vnd.ms-modi'
            , 'image/vnd.net-fpx'
            , 'image/vnd.sealed.png'
            , 'image/vnd.sealedmedia.softseal.gif'
            , 'image/vnd.sealedmedia.softseal.jpg'
            , 'image/vnd.svf'
            , 'image/vnd.wap.wbmp'
            , 'image/vnd.xiff'
            , 'application/msword'
            , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            , 'application/vnd.ms-powerpoint'
            , 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            , 'application/pdf'
      ],

      // Yayın formatı seçenekleri
      pubFormatOptions: ['Basılı Materyal', 'Elektronik Materyal'],

      // Kapak tipi seçenekleri
      coverTypeOptions: ['Elektronik Kapak', 'Sert Kapak', 'Yumuşak Kapak'],

      // Metin tipi seçenekleri
      textTypeOptions: [
            { id: 'tt_manzum', name: 'Manzum [Şiir]' },
            { id: 'tt_mensur', name: 'Mensur [Düzyazı]' },
            { id: 'tt_tenkit', name: 'Tenkitli Metin' },
            { id: 'tt_tipkibas', name: 'Tıpkıbasım' },
            { id: 'tt_derleme', name: 'Derleme' },
            { id: 'tt_uyarlama', name: 'Uyarlama [Adaptasyon]' },
      ]
}

if (process.env.NODE_ENV === "development") {
      console.log("Aktif olan ENV:", process.env.NODE_ENV);
      console.log("Aktif olan AConfig:", config);

}
export { config };
export default config;


export const orderStatusList = [
      {
            "id": 1,
            "value": "İşlem Reddedildi"
      },
      {
            "id": 2,
            "value": "İptal Edildi"
      },
      {
            "id": 3,
            "value": "Ödeme Bekliyor"
      },
      {
            "id": 4,
            "value": "İşlem Başladı"
      },
      {
            "id": 5,
            "value": "Ödeme Hatası : Host Bağlantı Hatası "
      },
      {
            "id": 6,
            "value": "Ödeme Başarılı"
      },
      {
            "id": 7,
            "value": "Sipariş Alındı"
      }
]


export const paymentTypeList = [
      {
            "id": 1,
            "value": "Kredi Kartı"
      },
      {
            "id": 2,
            "value": "Havale / EFT / Fast"
      }
]